import script from "./AdvertiserModalSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserModalSlide.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserModalSlide.vue?vue&type=style&index=0&id=72c7f015&lang=scss"

const __exports__ = script;

export default __exports__